import { cn } from "@/lib/utils";
import { useTheme } from "@/lib/theme";
import { PRODUCT_NAME } from "@repo/shared";

interface BrandLogoProps {
  className?: string;
  /** Force the light-on-dark (negative) asset regardless of the active theme — for dark panels. */
  onDark?: boolean;
}

export function BrandLogo({ className, onDark = false }: BrandLogoProps) {
  const { resolvedTheme } = useTheme();

  const src =
    onDark || resolvedTheme === "dark" ? "/senseguard-logo-negativo.svg" : "/senseguard-logo.svg";

  return <img src={src} alt={PRODUCT_NAME} className={cn("max-w-full shrink-0", className)} />;
}
